<template>
	<div class="settings modal">
		<div class="modal-wrap">
			<div class="modal-inner">
				<h2 class="modal-title">
					Coupon<span class="close" @click="close">X</span>
				</h2>

				<div class="modal-inner-scroll">
					<form class="form normal" @submit.prevent="saveSettings">

						<label v-if="!settings.joiner">Coupon Type</label>
						<v-select
							placeholder=""
							v-model="settings.amountOffType"
							:options="[
								{ label: 'Percent Off', value: 'percent' },
								{ label: 'Amount Off', value: 'amount' },
								{
									label: 'Custom Trial Length',
									value: 'trial',
								},
							]"
							:reduce="(option) => option.value"
							:disabled="typeof settings._id !== 'undefined'"
							v-if="!settings.joiner"
						/>

						<FormInput
							type="text"
							label="Code"
							v-model="settings.code"
							placeholder="Code"
							:disabled="typeof settings._id !== 'undefined'"
						/>

						<label v-if="settings.amountOffType !== 'trial'"
							>Joiner Coupon?</label
						>
						<v-select
							placeholder=""
							v-model="settings.joiner"
							:options="yesNo"
							:reduce="(option) => option.value"
							v-if="settings.amountOffType !== 'trial'"
						></v-select>

						<label
							v-if="
								settings.joiner &&
									settings.amountOffType !== 'trial'
							"
							>Joined Coupons</label
						>
						<v-select
							placeholder=""
							v-model="settings.joinedCoupons"
							:options="coupons"
							:multiple="true"
							label="code"
							:reduce="(option) => option._id"
							v-if="settings.joiner"
						></v-select>

						<label>Live?</label>
						<v-select
							placeholder=""
							v-model="settings.active"
							:options="yesNo"
							:reduce="(option) => option.value"
						></v-select>

						<FormInput
							type="number"
							:label="amountOffLabel"
							:min="amountOffMin"
							v-model="settings.amountOff"
							placeholder=""
							v-if="
								typeof settings.amountOffType !== 'undefined' &&
									settings.amountOffType !== null &&
									settings.amountOffType !== '' &&
									!settings.joiner
							"
							:disabled="typeof settings._id !== 'undefined'"
						/>

						<label
							v-if="
								!settings.joiner &&
									settings.amountOffType !== 'trial'
							"
							>Duration</label
						>
						<v-select
							placeholder="Duration"
							v-model="settings.duration"
							:options="[
								{ label: 'Once', value: 'once' },
								{ label: 'Repeating', value: 'repeating' },
								{ label: 'Forever', value: 'forever' },
							]"
							:reduce="(option) => option.value"
							:disabled="typeof settings._id !== 'undefined'"
							v-if="
								!settings.joiner &&
									settings.amountOffType !== 'trial'
							"
						></v-select>

						<FormInput
							type="number"
							label="Repeat For How Many Months?"
							min="0"
							v-model="settings.durationMonths"
							placeholder=""
							v-if="
								typeof settings.duration !== 'undefined' &&
									settings.duration === 'repeating' &&
									!settings.joiner
							"
							:disabled="
								typeof settings._id !== 'undefined' &&
									settings.amountOffType !== 'trial'
							"
						/>

						<VueCtkDateTimePicker
							v-model="settings.validFrom"
							:label="'Valid From'"
							color="#d20000"
							:no-label="true"
							v-if="!settings.joiner"
						/>

						<VueCtkDateTimePicker
							v-model="settings.validTo"
							:label="'Valid To'"
							color="#d20000"
							:no-label="true"
							v-if="!settings.joiner"
						/>

						<FormInput
							type="number"
							label="Max Usage Count (zero means unlimited)"
							min="0"
							v-model="settings.usageAllowed"
							placeholder="0"
							v-if="!settings.joiner"
						/>

						<FormInput
							type="text"
							label="User Emails - comma seperated list"
							v-model="settings.userEmails"
							placeholder=""
							v-if="!settings.joiner"
						/>

						<label
							v-if="
								!settings.joiner &&
									settings.amountOffType !== 'trial'
							"
							>Products</label
						>
						<v-select
							placeholder="All products"
							v-model="settings.products"
							:options="products"
							:reduce="(option) => option.value"
							:multiple="true"
							:disabled="typeof settings._id !== 'undefined'"
							v-if="
								!settings.joiner &&
									settings.amountOffType !== 'trial'
							"
						></v-select>

						<p
							class="error"
							v-if="typeof errors === 'string' && errors !== ''"
							v-html="errors"
						/>

						<span
							class="large-button"
							@click="updateCoupon"
							v-html="'Save'"
						/>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import { mapMutations } from "vuex";
	import ApiService from "./../services/api.service";
	import FormInput from "./Form/Input.vue";
	import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
	import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
	Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
	export default {
		name: "CouponSettings",
		components: {
			FormInput,
		},
		props: {
			settings: Object,
		},
		data() {
			return {
				errors: {},
				okToSubmit: true,
				products: [],
				joiner: false,
				coupons: [],
				n: [],
			};
		},
		computed: {
			buttonText() {
				return "Save";
			},
			yesNo() {
				return [
					{ label: "Yes", value: true },
					{ label: "No", value: false },
				];
			},
			amountOffLabel() {
				if (this.settings.amountOffType === "percent")
					return "Percentage Off";
				if (this.settings.amountOffType === "trial")
					return "Trial Period In Days";
				return "Amount Off In !!CENTS!!";
			},

			amountOffMin() {
				if (this.settings.amountOffType === "trial") return 1;
				return 0;
			},
		},
		mounted() {
			this.updateLoadingText("One moment...");

			ApiService.get("products")
				.then(
					function(info) {
						info.data.forEach(
							function(product) {
								this.products.push({
									label: product.label,
									value: product._id,
								});
							}.bind(this)
						);

						this.updateLoadingText();
					}.bind(this)
				)
				.catch(function(err) {
					console.log(err);
				});

			ApiService.post("admin/coupons", { all: true })
				.then(
					function(info) {
						Vue.set(this, "coupons", info.data.items);
					}.bind(this)
				)
				.catch(function(err) {
					console.log(err);
				});
		},

		methods: {
			...mapMutations("general", ["updateLoadingText"]),

			saveSettings() {
				if (!this.okToSubmit) return;
			},

			close() {
				this.$emit("close");
			},
			hasInternalErrors(a) {
				this.okToSubmit = a === true ? false : this.okToSubmit;
			},

			updateCoupon() {
				this.$emit("save", this.settings);
			},
		},
	};
</script>

<style lang="less" scoped>
	.modal {
		&.settings {
			.modal-inner {
				max-width: 550px;
			}
		}
	}
</style>
